<template>
  <div style="z-index: 999;">
    <!--顶部banner-->
    <div class="swiper-container">
      <swiper v-if="slidesTop && slidesTop.length" :options="swiperOptionsTop">
        <swiper-slide v-for="(slide, index) in slidesTop" :key="index">
          <div class="banner-img-wrapper">
            <img :src="bustCache(slide.image)" alt="slide" class="banner-img" style="cursor: pointer;"
                 @click="bannerTo(slide.link)"/>
          </div>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
      <!-- 占位：避免 swiper 异步初始化时容器尺寸计算错误（图片被拉伸/变形） -->
      <div v-else class="banner-img-wrapper"></div>
    </div>
    <!--滚动数字-->
    <!--<div :style="{ backgroundImage: `url(${homeCountBg})` }"
         style="width: 100%;height: 134px;background-size: cover;background-repeat: no-repeat;background-position: center;display: flex;justify-content: center;align-items: center;">
      <div style="width: 1300px;display: flex;align-items: center;justify-content: center;">
        <div style="display: flex;flex: 1;justify-content: center;">
          <img src="@/assets/img/homeCount1.png" style="width: 50px;height: 50px;"/>
          <div style="display: flex;flex-direction: column;padding-left: 12px;">
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 36px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;display: flex;height: 50px;display: flex;align-items: center;">
              <div style="font-size: 40px;">
                <CountTo
                    :duration='3000'
                    :endVal='80000'
                    :startVal='0'
                    separator=""
                />
              </div>
              <div style="font-size: 20px;margin-bottom: -10px;padding-left: 6px;">{{ $t('h.home.box1.label1') }}</div>
              <div style="padding: 6px;margin-top: -16px;font-weight: lighter;font-size: 28px;">+</div>
            </div>
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 26px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;">
              {{ $t('h.home.box1.content1') }}
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1;justify-content: center;">
          <img src="@/assets/img/homeCount2.png" style="width: 50px;height: 50px;"/>
          <div style="display: flex;flex-direction: column;padding-left: 12px;">
            <div
                style="font-family: SourceHanSansOLD-Bold;color: #FFFFFF;letter-spacing: 0;line-height: 32px;display: flex;height: 50px;display: flex;align-items: center;">
              <div style="font-size: 40px;">
                <CountTo
                    :duration='3000'
                    :endVal='41000'
                    :startVal='0'
                    separator=""
                />
              </div>
              <div style="font-size: 20px;margin-bottom: -10px;padding-left: 6px;">{{ $t('h.home.box1.label2') }}</div>
              <div style="padding: 6px;margin-top: -16px;font-weight: lighter;font-size: 28px;">+</div>
            </div>
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 26px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;">
              {{ $t('h.home.box1.content2') }}
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1;justify-content: center;">
          <img src="@/assets/img/homeCount3.png" style="width: 50px;height: 50px;"/>
          <div style="display: flex;flex-direction: column;padding-left: 12px;">
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 36px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;display: flex;height: 50px;display: flex;align-items: center;">
              <div style="font-size: 40px;">
                <CountTo
                    :duration='3000'
                    :endVal='1000'
                    :startVal='0'
                    separator=""
                />
              </div>
              <div style="font-size: 20px;margin-bottom: -10px;padding-left: 6px;">{{ $t('h.home.box1.label3') }}</div>
              <div style="padding: 6px;margin-top: -20px;font-weight: lighter;font-size: 28px;">+</div>
            </div>
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 26px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;">
              {{ $t('h.home.box1.content3') }}
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1;justify-content: center;">
          <img src="@/assets/img/homeCount4.png" style="width: 50px;height: 50px;"/>
          <div style="display: flex;flex-direction: column;padding-left: 12px;">
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 36px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;display: flex;height: 50px;display: flex;align-items: center;">
              <div style="font-size: 40px;">
                <CountTo
                    :duration='3000'
                    :endVal='60'
                    :startVal='0'
                />
              </div>
              <div style="font-size: 20px;margin-bottom: -10px;padding-left: 6px;">{{ $t('h.home.box1.label4') }}</div>
              <div style="padding: 6px;margin-top: -16px;font-weight: lighter;font-size: 28px;">+</div>
            </div>
            <div
                style="font-family: SourceHanSansOLD-Bold;font-size: 26px;color: #FFFFFF;letter-spacing: 0;line-height: 32px;">
              {{ $t('h.home.box1.content4') }}
            </div>
          </div>
        </div>
      </div>

    </div>-->
    <div style="width: 100%;height: auto;display: flex;justify-content: center">
      <div style="width: 1200px;height: auto;padding-top: 20px;padding-bottom: 20px;display:flex;">
        <div style="width:520px;height: 321px;overflow: hidden;border-radius: 6px;">
          <img class="customImage" :src="bustCache(language === 'ZH' ? shouyezuoceImg : shouyezuoceEnImg)"/>
        </div>
        <div style="width: 680px;">
          <div class="fontBold"
               style="padding: 12px 24px;text-indent: 2em;line-height: 32px;font-family: SourceHanSansCN-Medium, Arial, Helvetica, sans-serif;text-align: justify;padding-left: 60px;">
            <h1 class="home-h1" style="font-size: 22px;color: #d7000F;">{{ $t('h.home.h1') }}</h1>
            <span style="font-size: 18px;color: #444444;">{{ $t('h.home.box2.content') }}</span>
          </div>
          <div style="display: flex;justify-content: center;padding-left: 60px;">
            <a-button class="customBtn"
                      style="background: #d7000F;width: 189px;height: 48px;border: none;font-family: SourceHanSansCN-Medium;font-size: 20px;color: #FFFFFF;"
                      @click="homeBtn(1)">
              {{ $t('h.home.box2.btn1') }}
            </a-button>
            <div style="width: 60px;"></div>
            <a-button class="customBtn"
                      style="background: #d7000F;width: 189px;height: 48px;border: none;font-family: SourceHanSansCN-Medium;font-size: 20px;color: #FFFFFF;"
                      @click="homeBtn(2)">
              {{ $t('h.home.box2.btn2') }}
            </a-button>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 24px;padding-left: 60px;">
            <a-button class="customBtn"
                      style="background: #d7000F;width: 189px;height: 48px;border: none;font-family: SourceHanSansCN-Medium;font-size: 20px;color: #FFFFFF;"
                      @click="homeBtn(3)">
              {{ $t('h.home.box2.btn3') }}
            </a-button>
            <div style="width: 60px;"></div>
            <a-button class="customBtn"
                      style="background: #d7000F;width: 189px;height: 48px;border: none;font-family: SourceHanSansCN-Medium;font-size: 20px;color: #FFFFFF;"
                      @click="homeBtn(4)">
              {{ $t('h.home.box2.btn4') }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <!--展会动态-->
    <div :style="{ backgroundImage: `url(${zhanhuidongtaiBg})` }"
         style="width: 100%;height: 64px;background-size: cover;background-repeat: no-repeat;background-position: center;display: flex;justify-content: center;align-items: center;">
      <div style="display: flex;flex-direction: column;align-items: center">
        <div style="font-family: SourceHanSansCN-Heavy;font-size: 36px;color: #131313;font-weight: 500;">
          {{ $t('h.home.box3.title') }}
        </div>
      </div>
    </div>
    <!--展会动态列表-->
    <div style="width: 100%;height: auto;display: flex;justify-content: center">
      <div style="width: 1200px;height: auto;padding-top: 20px;padding-bottom: 20px;display:flex;">
        <div style="width: 800px;margin-right: 24px;padding: 12px;">
          <template v-for="(item,index) in exhibitionNews">
            <div :key="index"
                 style="display: flex;margin-bottom: 20px;cursor: pointer;"
                 @click="$router.push({path: '/dynamic-detail', query: {id: item.id}})">
              <div
                  style="width: 390px;height: 180px;border-radius: 6px;margin-right: 24px;cursor: pointer;overflow: hidden;">
                <img :src="bustCache(item[language === 'ZH' ? 'itemsCn' : 'itemsEn'].coverImage)"
                     class="customImage"
                     object-fit="cover"/>
              </div>
              <div
                  style="width: 420px;height: 180px;display: flex;flex-direction: column;justify-content: space-between;padding-top: 6px;">
                <div>
                  <div class="customLabel"
                       style="font-family: SourceHanSansCN-Medium;font-size: 16px;color: #444444;line-height: 24px;cursor: pointer;">
                    {{ item[language === 'ZH' ? 'itemsCn' : 'itemsEn'].title }}
                  </div>
                  <div
                      style="
                      font-family: SourceHanSansCN-Medium;
                      font-size: 14px;
                      color: #8D8D8D;
                      line-height: 22px;
                      margin-top: 6px;
                      cursor: pointer;
                      display:-webkit-box;
                      -webkit-box-orient:vertical;
                      -webkit-line-clamp:3;
                      overflow: hidden;
                      word-break:break-all;
                    "
                  >
                    {{ item[language === 'ZH' ? 'itemsCn' : 'itemsEn'].content }}
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-between">
                  <div
                      style="width: 183px;height: 28px;background-image: linear-gradient(270deg, #FFFFFF 0%, #d7000F 100%);border-radius: 2px;font-family: SourceHanSansCN-Medium;font-size: 14px;color: #FFFFFF;display: flex;align-items: center;padding-left: 12px;">
                    {{ $moment(item.updateTime || item.createTime).format('YYYY-MM-DD') }}
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div
                        style="font-family: SourceHanSansCN-Medium;font-size: 14px;color: #8D8D8D;padding-right: 6px;line-height: 22px;">
                      {{ $t('h.home.box4.label1') }}
                    </div>
                    <img src="@/assets/img/more.png" style="width: 18px;height: 18px;"/>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div style="width: 376px;padding-left: 24px;padding-right: 12px;padding-top: 24px;">
          <template v-for="(item,index) in exhibitionNewsRight">
            <div
                :key="index"
                style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 22px;cursor: pointer;"
                @click="$router.push({path: '/dynamic-detail', query: {id: item.id}})">
              <div class="customLabel line-two" style="font-size: 16px;color: #444444;width: 280px;">
                {{ item[language === 'ZH' ? 'itemsCn' : 'itemsEn'].title }}
              </div>
              <div style="display:flex;align-items: center;">
                <div
                    style="font-family: SourceHanSansCN-Medium;font-size: 14px;color: #8D8D8D;padding-right: 6px;line-height: 22px;">
                  {{ $t('h.home.box4.label2') }}
                </div>
                <img src="@/assets/img/more.png" style="width: 18px;height: 18px;"/>
              </div>
            </div>
          </template>
          <div
              style="width: 100%;height: auto;display: flex;align-items: center;justify-content: right;cursor: pointer;">
            <div
                style="font-family: SourceHanSansCN-Medium;font-size: 14px;color: #8D8D8D;padding-right: 6px;line-height: 22px;"
                @click="$router.push('/dynamic')">
              {{ $t('h.home.box4.label3') }}
            </div>
            <img src="@/assets/img/more.png" style="width: 18px;height: 18px;"/>
          </div>
        </div>
      </div>
    </div>
    <!--参展企业展示-->
    <div :style="{backgroundImage: `url(${bottomBg})`}"
         style="width: 100%;height: auto;background-size: cover;background-repeat: no-repeat;background-position: center;display: flex;flex-direction: column;align-items: center;padding-bottom: 20px;">
      <div
          style="font-family: SourceHanSansCN-Heavy;font-size: 36px;color: #d7000F;padding-top: 28px;padding-bottom: 10px;font-weight: 500;">
        {{ $t('h.home.box5.title') }}
      </div>

      <div style="margin-top: 24px;display: flex;flex-direction: column;align-items: center;width: 100%;">
        <div style="display:flex;justify-content: flex-start;width: 1100px;margin-bottom: 24px;">
          <div v-for="(item,index) in showTitle" :key="index" style="flex: 1;display: flex;justify-content: center;"
               @click="itemClick(index)">
            <a-button v-if="item.select" class="customBtn"
                      style="background: #d7000F;height: 42px;border: none;font-size: 20px;color: #FFFFFF;width: 100%;">
              {{ item.title }}
            </a-button>
            <a-button v-else class="customBtn"
                      style="background: none;height: 42px;;border: none;font-size: 20px;color: #343434;width: 100%;"
                      type="link">
              {{ item.title }}
            </a-button>
          </div>
        </div>
        <div style="width: 1200px;height: auto;display: flex;justify-content: center;position: relative;">
          <div class="icons">
            <swiper ref="mySwiper" :options="swiperOption">
              <swiper-slide v-for='(item, index) in page' :key='index'>
                <div v-for="page in item" :key="page.id" class="icons-item">
                  <a :href="page.linkAddress" target="_blank">
                    <img :src="bustCache(page.coverImage)" class="customImage" style="padding: 10px;">
                  </a>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountTo from 'vue-count-to'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import {addExhibition, banner, displayCompany, queryArticlePageList} from "@/assets/api";
import {EventBus} from "@/assets/event-bus";
import homeCountBg from '@/assets/img/homeCountBg.png'
import zhanhuidongtaiBg from '@/assets/img/zhanhuidongtai.png'
import bottomBg from '@/assets/img/bottombg.png'
import shouyezuoceImg from '@/assets/img/shouyezuoce.jpg'
import shouyezuoceEnImg from '@/assets/img/shouyezuoce-en.jpg'

const publichPath = process.env.BASE_URL

export default {
  components: {
    CountTo,
    Swiper,
    SwiperSlide
  },
  computed: {
    page() {
      let pages = [];
      let i = 0;
      if (this.iconsList.length) {
        this.iconsList.forEach((item, index) => {
          if (index === 0) {
            i = 0;
            pages[0] = [item]
          } else if (index === 15) {
            i = 1;
            pages[1] = [item]
          } else if (index === 30) {
            i = 2;
            pages[2] = [item]
          } else if (index === 45) {
            i = 2;
            pages[2] = [item]
          } else if (index === 60) {
            i = 2;
            pages[2] = [item]
          } else if (index === 75) {
            i = 2;
            pages[2] = [item]
          } else if (index === 90) {
            i = 2;
            pages[2] = [item]
          } else {
            pages[i].push(item)
          }
        })
      }
      return pages
    }
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('h.vistorRegister.title2Box.holder11')));
      }
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailReg.test(value)) {
        callback(new Error(this.$t('h.vistorRegister.title2Box.holder17')));
      } else {
        callback();
      }
    };
    return {
      homeCountBg,
      zhanhuidongtaiBg,
      bottomBg,
      shouyezuoceImg,
      shouyezuoceEnImg,
      language: this.$language,
      // 图片缓存破坏版本号：每次进入页面生成一次，确保后端直接替换图片后老用户也能拉到最新图
      imgVersion: Date.now(),
      exhibitionNews: [],
      exhibitionNewsRight: [],
      swiperOptionsTop: {
        loop: true, // 循环模式
        autoplay: {
          delay: 5000, // 自动播放的间隔
          disableOnInteraction: false, // 用户交互后是否停止自动播放
        },
        pagination: {
          el: '.swiper-pagination', // 指定分页器的HTML元素
          clickable: true, // 允许点击分页器来切换幻灯片
        },
      },
      slidesTop: [
        // '@/assets/img/banner/banner1.png',
        // '@/assets/img/banner/banner2.png',
        // '@/assets/img/banner/banner3.png',
      ],
      slides: [
        {image: 'path-to-image-1.jpg'},
        {image: 'path-to-image-2.jpg'},
        // 更多图片...
      ],
      iconsList: [],
      swiperOption: {
        effect: 'flip', // 使用渐变效果
        //配置导航
        navigation: {
          nextEl: '.swiper-button-next',//下一页dom节点
          prevEl: '.swiper-button-prev'//前一页dom节点
        },
        // 循环轮播配置
        loop: false
      },
      showTitle: [
        {
          title: this.$t('h.home.box5.tab1'),
          select: true,
          code: "2-1",
          type: '1'
        },
        {
          title: this.$t('h.home.box5.tab2'),
          select: false,
          code: "2-2",
          type: '2'
        },
        {
          title: this.$t('h.home.box5.tab3'),
          select: false,
          code: "2-3",
          type: '3'
        },
        {
          title: this.$t('h.home.box5.tab4'),
          select: false,
          code: "2-4",
          type: '4'
        },
        {
          title: this.$t('h.home.box5.tab5'),
          select: false,
          code: "2-5",
          type: '5'
        }
      ],
      subscribeDialog: false,
      subscribeForm: {
        roleName: undefined,
        companyName: null,
        contactName: null,
        email: null
      },
      formRules: {
        roleName: [{required: true, message: this.$t('h.subscribeDialog.holder1'), trigger: 'change'}],
        companyName: [{required: true, message: this.$t('h.subscribeDialog.holder2'), trigger: 'blur'}],
        contactName: [{required: true, message: this.$t('h.subscribeDialog.holder3'), trigger: 'blur'}],
        email: [{required: true, message: this.$t('h.subscribeDialog.holder4'), trigger: 'blur'}, {
          validator: validateEmail,
          trigger: 'blur'
        }],
      }
    }
  },
  created() {
    this.getBanner();
    // this.$axios.get(queryArticlePageList + "?code=C06A02", {}).then(res => {
    //   if (res.data.success) {
    //     this.exhibitionNews = res.data.result.records
    //     this.exhibitionNewsRight = this.exhibitionNews.splice(2)
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // })
    // 修改展会动态获取部分（增加请求数量并优化过滤）
    this.$axios.get(queryArticlePageList + `?categoryId=1776862661877743617&pageNo=1&pageSize=50`, {}).then(res => {
      if (res.data.success) {
        this.exhibitionNews = res.data.result.records
          .filter(item => {
            const target = this.language === 'ZH' ? item.itemsCn : item.itemsEn;
            return target && target.title && target.title.trim();
          })
          .slice(0, 2);
      } else {
        this.$message.error(res.data.message)
      }
    })
    
    // 修改右侧动态获取部分
    this.$axios.get(queryArticlePageList + `?categoryId=1776862725224316930&pageNo=1&pageSize=50`, {}).then(res => {
      if (res.data.success) {
        this.exhibitionNewsRight = res.data.result.records
          .filter(item => {
            const target = this.language === 'ZH' ? item.itemsCn : item.itemsEn;
            return target && target.title && target.title.trim();
          })
          .slice(0, 5);
      }
    })
    this.getImgPageList();
  },
  mounted() {
    EventBus.$on('subscribeDialog', (submenu) => {
      if (this.subscribeDialog) {
        return false;
      }
      this.subscribeForm = {
        roleName: undefined,
        companyName: null,
        contactName: null,
        email: null
      }
      this.subscribeDialog = true
    });
  },
  methods: {
    // 给后端返回的图片URL追加版本号，避免浏览器命中旧缓存导致图片替换后老用户看不到更新
    bustCache(url) {
      if (!url) return url
      const sep = url.indexOf('?') >= 0 ? '&' : '?'
      return `${url}${sep}v=${this.imgVersion}`
    },
    getBanner() {
      this.$axios.get(banner).then(res => {
        this.slidesTop = res && res.data ? res.data : []
      })
    },
    bannerTo(url) {
      if (!url) {
        return false
      }
      window.open(url)
    },
    getImgPageList() {
      // let code = null
      let type = null
      this.showTitle.forEach(item => {
        if (item.select) {
          // code = item.code
          type = item.type
        }
      })
      this.$axios.get(displayCompany + '?type=' + type, {}).then(res => {
        if (res && res.data.success) {
          this.iconsList = res.data.result
        } else {
          this.$message.error(res.data.message)
        }
      })
      // this.$axios.get(queryVideoImgPageList, {
      //   params: {
      //     pageSize: '90',
      //     code: code
      //   }
      // }).then(res => {
      //   if (res.data.success) {
      //     this.iconsList = res.data.result.records
      //   } else {
      //     this.$message.error(res.data.message)
      //   }
      // })
    },
    subscribeConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$axios.post(addExhibition, this.subscribeForm).then(res => {
            if (res && res.data.success) {
              this.$message.success(res.data.message)
              this.subscribeDialog = false
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      });
    },
    homeBtn(index) {
      switch (index) {
        case 1:
          this.$router.push('/about')
          break;
        case 2:
          // 智慧导览：31huiyi 展馆平面图，按语言切换参数
          window.open(
            this.language === 'ZH'
              ? 'https://booth-inquiry.31huiyi.com/boothplan?exhibitionId=019eede8-6ffd-7992-a91c-231bb8552d6e'
              : 'https://booth-inquiry.31huiyi.com/boothplan?exhibitionId=019eede8-6ffd-7992-a91c-231bb8552d6e&lang=en',
            '_blank'
          )
          // window.open(process.env.BASE_URL + 'file/2024zhanguanfenbutu.png', '_blank')
          break;
        case 3:
          // window.open('https://book.yunzhan365.com/eqdbv/tpcf/mobile/index.html', '_blank')
		  window.open(this.language === 'ZH' ? 'https://book.yunzhan365.com/eqdbv/szdn/mobile/index.html' : 'https://book.yunzhan365.com/eqdbv/szdn/mobile/index.html', '_blank')
          break;
        case 4:
         window.open('/resource-center', '_blank')
		  // window.open(this.language === 'ZH' ? 'https://book.yunzhan365.com/eqdbv/guwf/mobile/index.html' : 'https://book.yunzhan365.com/eqdbv/snlo/mobile/index.html', '_blank')
          break;
      }
    },
    itemClick(index) {
      this.showTitle.forEach((item) => {
        item.select = false
      })
      this.showTitle[index].select = true
      this.$nextTick(() => {
        this.getImgPageList();
      })
    }
  }
}
;
</script>
<style lang="scss" scoped>
/* 首页 H1：保持与原 span 完全一致的内联样式，仅替换标签用于 SEO 语义 */
.home-h1 {
  display: inline;
  margin: 0;
  padding: 0;
  font-weight: inherit;
  line-height: inherit;
  vertical-align: baseline;
}

.icons {
  width: 1100px;
  height: auto;
  overflow: hidden;
}

.icons-item {
  width: 19%;
  height: 108px;
  margin: 5.4px;
  float: left;
  overflow: hidden;
  border-radius: 6px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icons-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height:110px;
}

.swiper-container {
  width: 100%;
  box-sizing: border-box;
  /* banner 容器用 aspect-ratio 锁定比例，避免不同屏幕宽度下宽度/高度不匹配导致裁剪 */
  height: auto;
  aspect-ratio: 1920 / 600;
  overflow: hidden;
}

/* 大屏 2K 及以上适当放大，保持视觉平衡（1920×720 = 8:3，与常见 banner 图片比例匹配） */
@media (min-width: 1920px) {
  .swiper-container {
    aspect-ratio: 1920 / 720;
  }
}

/* 笔记本小屏 */
@media (max-width: 1366px) {
  .swiper-container {
    aspect-ratio: 1366 / 480;
  }
}

/* 平板以下 */
@media (max-width: 992px) {
  .swiper-container {
    aspect-ratio: 992 / 360;
  }
}

/* swiper-slide 继承容器宽高，确保图片容器与 slide 完全对齐 */
.swiper-slide {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

/* banner-img-wrapper 严格填满 slide，不发生任何裁剪溢出 */
.banner-img-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}

.swiper-slide img.banner-img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center center;
}

.swiper-pagination {
  /* 自定义分页器样式 */
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

::v-deep .swiper-pagination-bullet {
  /* 自定义单个分页器点的样式 */
  width: 20px;
  height: 20px;
  background: #D8D8D8;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.20);
  border-radius: 50%;
  opacity: 1;
  margin: 0 5px;
}

::v-deep .swiper-pagination-bullet-active {
  /* 自定义当前活动分页器点的样式 */
  background-color: #d7000F;
  opacity: 1;
}
.line-two {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

</style>
